import React, { ReactNode } from 'react';
import moment from 'moment';
import type { PostalRegistration } from '@/types/database/postalRegistration';
import axios from 'axios';

export const getDetailList = (data: PostalRegistration) => {
  let list: {
    label: string;
    content: ReactNode;
  }[] = [
    {
      label: '包裹登記時間',
      content: moment(data.packagerRegistrationTime).format(
        'YYYY/MM/DD HH:mm:ss'
      ),
    },
    {
      label: '包裹類型',
      content: data.packageType,
    },
    {
      label: '戶號',
      content: data.household,
    },
    {
      label: '收件人',
      content: data.recipient || '無資料',
    },
    {
      label: '擺放位置',
      content: data.placement,
    },
    {
      label: '廠商',
      content: data.vendor || '無資料',
    },
    {
      label: '物流',
      content: data.logistics || '無資料',
    },
    {
      label: '備註',
      content: data.remarks || '無資料',
    },
  ];
  if (['已領取', '已退回'].includes(data.status)) {
    list.push({
      label: '領取時間',
      content: moment(data.receiveTime).format('YYYY/MM/DD HH:mm:ss'),
    });
  }
  list = [
    ...list,
    {
      label: '條碼',
      content: data.barcode || '無資料',
    },
    {
      label: '領取人照片',
      content: data.residentPhoto ? (
        <img src={data.residentPhoto} alt="住戶照片" width={300} />
      ) : (
        '無資料'
      ),
    },
    {
      label: '領取人簽名',
      content: data.canvas ? (
        <img src={data.canvas} alt="住戶簽名" width={300} height={300} />
      ) : (
        '無資料'
      ),
    },
  ];
  return list;
};

export const sendInfo = (item: PostalRegistration) => {
  const query: Record<string, any> = {
    firebaseClass: '郵件包裹',
  };
  if (item.userObjectId) {
    query._id = item.userObjectId;
  } else {
    query.householdNumbers = item.household;
  }
  return axios('/ezcon/api/emitMsgQuery', {
    method: 'POST',
    headers: {
      authorization: window.localStorage['feathers-jwt'],
    },
    data: {
      service: 'message',
      event: 'msg',
      title: '包裹通知',
      // 戶號“您有新的包裹類型請快來領取：時間
      content: `${item.household}您有新的${item.packageType}請快來領取:${moment(
        item.packagerRegistrationTime
      ).format('YYYY-MM-DD HH:mm:ss')}`,
      type: 'success',
      class: 'postalRegistration',
      duration: 8000,
      redirect: '/ezpro/postal/postalFrontDesk',
      query,
    },
  });
};
